<template>
  <div class="container" id="RecoveryPassword">
    <div class="row navbar-uli justify-content-between">
      <div class="col-6 text-left">
        <a href="/login">
          <i class="fas fa-chevron-left"></i>
        </a>
      </div>
      <div class="col-6 text-right"></div>
    </div>
    <div class="row justify-content-center total-login">
      <div class="col-12">
        <h1>Recuperar a senha</h1>
      </div>
      <div class="col-12 mt-3" v-if="!sendEmail">
        <p>Digite o endereço de e-mail usado para criar sua conta</p>
        <br>
        <br>
      </div>
      <form novalidate="true" v-if="!sendEmail">
        <input v-model="email" type="email" placeholder="Digite seu e-mail">
        <p>{{errors}}</p>
        <button @click.prevent="validateForm" class="btn btn-primario mt-4 btn-medium">Encaminhar</button>
      </form>
      <div class="col-11 mt-3" v-else>
        <p>
          Um e-mail foi enviado para
          <br>
          <strong>{{email}}</strong>
          <br>Clique no link no e-mail para redefinir sua senha.
          <br>Não esqueça de checar sua caixa de spam
        </p>
        <p class="mt-5">
          <span class="resend-buton" @click="resendEmail">{{resendMessage}}</span>
        </p>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "RecoveryPassword",
  data() {
    return {
      email: "",
      errors: "",
      sendEmail: false,
      resendMessage: "Reenviar e-mail",
      busyAxios: false,
      ROOT_API: null
    };
  },
  methods: {
    validateForm,
    validEmail,
    requestNewPassword,
    resendEmail
  },
  created() {
    this.ROOT_API = process.env.ROOT_API;
  }
};
function validEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
function validateForm() {
  this.errors = "";
  if (!this.email) {
    this.errors = "E-mail vazio.";
  } else if (!this.validEmail(this.email)) {
    this.errors = "Insira um e-mail válido.";
  } else {
    this.requestNewPassword();
  }
}
function requestNewPassword() {
  let formData = new FormData();
  formData.append("email", this.email);
  axios({
    method: "post",
    url: this.ROOT_API + "api/password/forgot",
    data: formData,
    config: { headers: { "Content-Type": "multipart/form-data" } }
  }).then(response => {
    if (response.data.status == 1) {
      this.sendEmail = true;
    } else {
      this.errors = response.data.error;
    }
  });
}
function resendEmail() {
  if (!this.busyAxios) {
    this.busyAxios = true;
    this.resendMessage = "Reenviando e-mail...";
    let formData = new FormData();
    formData.append("email", this.email);
    axios({
      method: "post",
      url: this.ROOT_API + "api/password/forgot",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } }
    })
      .then(response => {
        if (response.data.status == 1) {
          this.sendEmail = true;
        } else {
          this.errors = response.data.error;
        }
      })
      .finally(() => {
        this.resendMessage = "E-mail reenviado";
        setTimeout(() => {
          this.busyAxios = false;
          this.resendMessage = "Reenviar e-mail";
        }, 2000);
      });
  }
}
</script>

<style scoped>
.navbar-uli {
  padding-top: 11px;
  margin-bottom: 10px;
}
.navbar-uli a {
  color: #000;
  font-size: 16px;
}
.navbar-uli a:hover {
  text-decoration: none;
}
.logo-uli img {
  height: 118px;
  margin-top: 14px;
  margin-bottom: 20px;
}
.total-login {
  margin-top: 24px;
}
.total-login h1 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.total-login p {
  color: #777777;
  margin-bottom: 0;
}
form {
  width: 80%;
  max-width: 345px;
}
input[type="email"] {
  margin: 0 0 18px 0;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  padding: 6px 0 0 0;
}
input[type="email"]::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000;
  font-size: 16px;
  opacity: 1; /* Firefox */
}
input[type="email"]:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #000;
  font-size: 16px;
}
input[type="email"]::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #000;
  font-size: 16px;
}
.resend-buton:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/RecoveryPassword.vue